import { useEffect, useState } from 'react';
import API from '../api';

const STATUS = { new:'Новая', in_progress:'В работе', done:'Выполнена', cancelled:'Отменена' };
const S_COLOR = { new:'#3B82F6', in_progress:'#F97316', done:'#22C55E', cancelled:'#EF4444' };
const S_BG    = { new:'#EFF6FF', in_progress:'#FFF7ED', done:'#F0FDF4', cancelled:'#FEF2F2' };

const inp = { padding:'10px 13px', border:'1.5px solid #E5E7EB', borderRadius:9, fontSize:'0.875rem', outline:'none', fontFamily:"'Golos Text',sans-serif", background:'#FAFAFA' };
const Badge = ({ s }) => <span style={{ padding:'3px 10px', borderRadius:20, fontSize:'0.72rem', fontWeight:700, background:S_BG[s]||'#F5F5F5', color:S_COLOR[s]||'#6B7280', whiteSpace:'nowrap' }}>{STATUS[s]||s}</span>;

function Toast({ msg, type, onDone }) {
  useEffect(() => { const t = setTimeout(onDone, 2800); return ()=>clearTimeout(t); }, [onDone]);
  const colors = { success:{ bg:'#F0FDF4', color:'#166534', border:'#BBF7D0' }, error:{ bg:'#FEF2F2', color:'#991B1B', border:'#FECACA' } };
  const c = colors[type] || colors.success;
  return <div style={{ position:'fixed', bottom:24, right:24, zIndex:9999, background:c.bg, color:c.color, border:`1px solid ${c.border}`, padding:'12px 20px', borderRadius:12, fontWeight:600, fontSize:'0.875rem', boxShadow:'0 4px 20px rgba(0,0,0,0.1)' }}>{msg}</div>;
}

function Modal({ order, onClose, onStatus }) {
  return (
    <div style={{ position:'fixed', inset:0, background:'rgba(0,0,0,0.4)', zIndex:999, display:'grid', placeItems:'center', padding:24 }} onClick={onClose}>
      <div style={{ background:'#fff', borderRadius:18, padding:'28px 28px', width:'100%', maxWidth:480, boxShadow:'0 20px 60px rgba(0,0,0,0.15)' }} onClick={e=>e.stopPropagation()}>
        <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center', marginBottom:22 }}>
          <h2 style={{ fontFamily:"'Unbounded',sans-serif", fontWeight:800, fontSize:'1.1rem', margin:0 }}>Заявка #{String(order.id).slice(-5)}</h2>
          <div style={{ display:'flex', alignItems:'center', gap:10 }}>
            <Badge s={order.status}/>
            <button onClick={onClose} style={{ background:'#F5F5F5', border:'none', borderRadius:8, width:30, height:30, cursor:'pointer', fontSize:'1rem', display:'grid', placeItems:'center' }}>✕</button>
          </div>
        </div>
        <div style={{ display:'grid', gap:10, marginBottom:22, background:'#FAFAFA', borderRadius:12, padding:'16px 18px' }}>
          {[['Клиент',order.name],['Телефон',order.phone],['Услуга',order.service||'—'],['Площадь',order.area?`${order.area} м²`:'—'],['Дата',order.date||'—'],['Примечание',order.note||'—'],['Создана',new Date(order.createdAt).toLocaleString('ru-RU')]].map(([l,v])=>(
            <div key={l} style={{ display:'flex', gap:8, alignItems:'flex-start' }}>
              <span style={{ color:'#9CA3AF', fontSize:'0.82rem', minWidth:110, paddingTop:1 }}>{l}</span>
              <span style={{ fontWeight:600, fontSize:'0.875rem', color:'#111', flex:1 }}>{v}</span>
            </div>
          ))}
        </div>
        <div style={{ marginBottom:4, fontSize:'0.78rem', fontWeight:700, color:'#6B7280', textTransform:'uppercase', letterSpacing:'0.05em', marginBottom:8 }}>Статус</div>
        <div style={{ display:'flex', gap:8, flexWrap:'wrap' }}>
          {Object.entries(STATUS).map(([k,v])=>(
            <button key={k} onClick={()=>onStatus(order.id,k)} style={{ padding:'7px 14px', borderRadius:8, border:`1.5px solid ${order.status===k?S_COLOR[k]:'#E5E7EB'}`, fontWeight:700, fontSize:'0.78rem', cursor:'pointer', background:order.status===k?S_BG[k]:'#fff', color:order.status===k?S_COLOR[k]:'#6B7280', transition:'all .15s' }}>{v}</button>
          ))}
        </div>
      </div>
    </div>
  );
}

export default function AdminOrders() {
  const [orders, setOrders]   = useState([]);
  const [filter, setFilter]   = useState('all');
  const [search, setSearch]   = useState('');
  const [selected, setSelected] = useState(null);
  const [toast, setToast]     = useState(null);

  const load = () => API.get('/admin/orders').then(r=>setOrders(r.data)).catch(()=>{});
  useEffect(()=>{ load(); },[]);

  const changeStatus = async (id, status) => {
    await API.put(`/admin/orders/${id}/status`,{ status });
    load(); setSelected(p=>p?{...p,status}:null);
    setToast({ msg:'Статус обновлён', type:'success' });
  };
  const del = async id => {
    if (!window.confirm('Удалить заявку?')) return;
    await API.delete(`/admin/orders/${id}`); load(); setSelected(null);
    setToast({ msg:'Заявка удалена', type:'success' });
  };

  const filtered = orders.filter(o => {
    const ms = filter==='all'||o.status===filter;
    const q  = search.toLowerCase();
    const mq = !q||o.name?.toLowerCase().includes(q)||o.phone?.includes(q)||o.service?.toLowerCase().includes(q);
    return ms&&mq;
  });
  const counts = { all:orders.length, ...Object.fromEntries(Object.keys(STATUS).map(k=>[k,orders.filter(o=>o.status===k).length])) };

  return (
    <div>
      {toast && <Toast msg={toast.msg} type={toast.type} onDone={()=>setToast(null)}/>}
      {selected && <Modal order={selected} onClose={()=>setSelected(null)} onStatus={changeStatus}/>}

      <div style={{ marginBottom:22 }}>
        <h1 style={{ fontFamily:"'Unbounded',sans-serif", fontWeight:800, fontSize:'1.4rem', color:'#06101e', margin:'0 0 4px' }}>Заявки</h1>
        <p style={{ color:'#9CA3AF', fontSize:'0.875rem', margin:0 }}>Управление входящими заявками</p>
      </div>

      {/* Filters */}
      <div style={{ display:'flex', gap:10, marginBottom:18, flexWrap:'wrap', alignItems:'center' }}>
        <div style={{ display:'flex', gap:6, flexWrap:'wrap' }}>
          {[['all','Все'],['new','Новые'],['in_progress','В работе'],['done','Выполнены'],['cancelled','Отменены']].map(([k,l])=>(
            <button key={k} onClick={()=>setFilter(k)} style={{ padding:'7px 14px', borderRadius:8, border:'1.5px solid', fontSize:'0.8rem', fontWeight:700, cursor:'pointer', transition:'all .15s', background:filter===k?'#06101e':'#fff', color:filter===k?'#fff':'#6B7280', borderColor:filter===k?'#06101e':'#E5E7EB' }}>
              {l} <span style={{ opacity:0.5 }}>({counts[k]||0})</span>
            </button>
          ))}
        </div>
        <input value={search} onChange={e=>setSearch(e.target.value)} placeholder="Поиск..." style={{ ...inp, marginLeft:'auto', minWidth:220 }}/>
      </div>

      {/* Table */}
      <div style={{ background:'#fff', borderRadius:14, boxShadow:'0 1px 8px rgba(0,0,0,0.06)', border:'1px solid #F0F0F0', overflow:'hidden' }}>
        {filtered.length===0 ? (
          <div style={{ padding:56, textAlign:'center', color:'#D1D5DB' }}>
            <div style={{ fontSize:'2.5rem', marginBottom:10 }}>📭</div>
            Заявок не найдено
          </div>
        ) : (
          <div style={{ overflowX:'auto' }}>
            <table style={{ width:'100%', borderCollapse:'collapse' }}>
              <thead>
                <tr style={{ background:'#FAFAFA' }}>
                  {['#','Клиент','Телефон','Услуга','Дата','Статус',''].map(h=>(
                    <th key={h} style={{ padding:'10px 16px', textAlign:'left', fontSize:'0.7rem', fontWeight:700, color:'#9CA3AF', textTransform:'uppercase', letterSpacing:'0.06em', whiteSpace:'nowrap' }}>{h}</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {filtered.map(o=>(
                  <tr key={o.id} style={{ borderTop:'1px solid #F5F5F5' }} onMouseOver={e=>e.currentTarget.style.background='#FAFAFA'} onMouseOut={e=>e.currentTarget.style.background='#fff'}>
                    <td style={{ padding:'11px 16px', color:'#D1D5DB', fontSize:'0.75rem', fontWeight:600 }}>#{String(o.id).slice(-5)}</td>
                    <td style={{ padding:'11px 16px', fontWeight:700, fontSize:'0.875rem', color:'#111' }}>{o.name}</td>
                    <td style={{ padding:'11px 16px', color:'#6B7280', fontSize:'0.85rem' }}>{o.phone}</td>
                    <td style={{ padding:'11px 16px', fontSize:'0.85rem', color:'#374151', maxWidth:150, overflow:'hidden', textOverflow:'ellipsis', whiteSpace:'nowrap' }}>{o.service||'—'}</td>
                    <td style={{ padding:'11px 16px', color:'#9CA3AF', fontSize:'0.78rem', whiteSpace:'nowrap' }}>{o.date||new Date(o.createdAt).toLocaleDateString('ru-RU')}</td>
                    <td style={{ padding:'11px 16px' }}><Badge s={o.status}/></td>
                    <td style={{ padding:'11px 16px' }}>
                      <div style={{ display:'flex', gap:6 }}>
                        <button onClick={()=>setSelected(o)} style={{ padding:'5px 12px', background:'rgba(0,194,184,0.08)', color:'#00C2B8', border:'none', borderRadius:7, fontWeight:700, fontSize:'0.75rem', cursor:'pointer' }}>Открыть</button>
                        <button onClick={()=>del(o.id)} style={{ padding:'5px 9px', background:'#FEF2F2', color:'#EF4444', border:'none', borderRadius:7, fontWeight:700, fontSize:'0.75rem', cursor:'pointer' }}>✕</button>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
}
